import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "requiredIndicatorName" })
export class RequiredIndicatorNamePipe implements PipeTransform {

	transform(value: number): string {
		if (value === undefined || value === null || Number.isNaN(value) || typeof value !== "number") {
			return "";
		}
		switch (value) {
			case 0:
				return "No";
			case 1:
				return "Required";
			case 2:
				return "Desired";
		}
		return "";
	}

}
